export default {
	name:'popup',
	props:{ //验证
		show:{ //验证弹窗显示隐藏必须是Number
			type:[Boolean,Number],
			default:false
		},
		title:{ //定制title
			type:[String,Number], //可以是多种类型
			default(){
				return ''
			}
		},
		className:{ //定制class
			type:String,
			default(){
				return ''
			}
		},
		cancelName:{ //定制取消按钮
			type:String,
			default(){
				return ''
			}
		}
	},
	data(){
		return{
		
		}
	},
	methods:{
		closeHandle(){ //关闭
			this.$emit('update:show',0);
		},
		sureHandle(){  //确定
			this.$emit('update:show',0);
		},
		cancelHandle(){ //取消
			this.$emit('update:show',0);
		}
	}
}